<template>
   <nav-bar title="处理举报" />
  <Content :bottom="0">
    <van-form class="form" @submit="handleSubmit">
      <van-field
        v-model="message"
        rows="3"
        autosize
        label="办结说明"
        type="textarea"
        placeholder="请输入办结说明"
         :rules="[{ required: true, message: '请填写办结说明' }]"
      />
      <van-field name="uploader" label="办结图片" >
        <template #input>
          <van-uploader  v-model="fileList" :after-read="afterRead"  />
        </template>
      </van-field>
      <div class="btn">
        <van-button block type="primary" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { updateFinishMess } from '@/api/user'
import { useSubmit } from '@/hooks/useSubmit'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import getImgFile from '@/utils/getImgFile'
export default {
  name: 'HandlingReports',
  props: ['reportId'],
  setup (props) {
    const store = useStore()
    const userId = computed(() => store.state.userInfo.id)
    const userName = computed(() => store.state.userInfo.name)
    // 文件上传
    const fileList = ref([])
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList)
    }
    const router = useRouter()
    const message = ref('')
    const handleSubmit = () => {
      const params = {
        reportId: props.reportId,
        finishRemark: message.value,
        finishUserId: userId.value,
        finishUserName: userName.value,
        imgList: imgPath.value
      }
      const { onSubmit } = useSubmit(updateFinishMess, params, () => {
        router.back()
      })
      onSubmit()
    }
    return { message, handleSubmit, fileList, afterRead, imgPath }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 0px;
}
.btn {
  margin: 16px;
}
</style>
